// extracted by mini-css-extract-plugin
module.exports = {"container":"CompetitionsList_container__3Wisw","header":"CompetitionsList_header__1HszH"};